import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useRef } from 'react'; // eslint-disable-next-line consistent-default-export-name/default-import-match-filename

import useSWRInfinite from 'swr/infinite';
import { TaskViewType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { withPageTitle } from '@poplar/components/withPageTitle';
import { API_TASKS_LIST_LITES } from '@poplar/constants/routes';
import { fetcher } from '@yoweb/utils/common';
import TodosPageV2 from '@poplar/components/tasks/TodosPageV2';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { useUser } from '@poplar/hooks/useUser';
import { jsx as _jsx } from "react/jsx-runtime";

var getKeyFactory = function getKeyFactory(filter, swrCacheKey, isAuthenticated) {
  return function (pageIndex, previousPageData) {
    if (!isAuthenticated || previousPageData && !previousPageData.encodedNextPageToken) {
      return null; // reached the end
    }

    var endpoint = API_TASKS_LIST_LITES;
    endpoint = "".concat(endpoint, "?filter=").concat(filter, "&page=").concat(pageIndex);

    if (previousPageData !== null && previousPageData !== void 0 && previousPageData.encodedNextPageToken) {
      endpoint = "".concat(endpoint, "&nextPageToken=").concat(previousPageData === null || previousPageData === void 0 ? void 0 : previousPageData.encodedNextPageToken);
    } // Note: swrCacheKey is provided here so that SWR scopes the results to the same page instance
    // which is a timestamp set on the server at the time of initial render.
    // This ensures the cache does not bleed between page visits.


    return endpoint + "&swrCacheKey=".concat(swrCacheKey);
  };
};

var commonSwrConfig = {
  revalidateOnMount: false,
  shouldRetryOnError: false
};

var TodosV2Page = function TodosV2Page(_ref) {
  var feedbackCategories = _ref.feedbackCategories,
      tasksDraft = _ref.tasksDraft,
      tasksComplete = _ref.tasksComplete,
      tasksUpcoming = _ref.tasksUpcoming,
      tasksInProgress = _ref.tasksInProgress,
      swrCacheKey = _ref.swrCacheKey;

  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;

  var infoMyTodos = useSWRInfinite(getKeyFactory(TaskViewType.TASK_VIEW_TYPE_MY_TO_DOS, swrCacheKey, isAuthenticated), fetcher, _objectSpread({
    fallbackData: [tasksDraft]
  }, commonSwrConfig));
  var infoUpcoming = useSWRInfinite(getKeyFactory(TaskViewType.TASK_VIEW_TYPE_UPCOMING, swrCacheKey, isAuthenticated), fetcher, _objectSpread({
    fallbackData: [tasksUpcoming]
  }, commonSwrConfig));
  var infoInProgress = useSWRInfinite(getKeyFactory(TaskViewType.TASK_VIEW_TYPE_IN_PROGRESS, swrCacheKey, isAuthenticated), fetcher, _objectSpread({
    fallbackData: [tasksInProgress]
  }, commonSwrConfig));
  var infoCompleted = useSWRInfinite(getKeyFactory(TaskViewType.TASK_VIEW_TYPE_COMPLETED, swrCacheKey, isAuthenticated), fetcher, _objectSpread({
    fallbackData: [tasksComplete]
  }, commonSwrConfig));

  var _useTasks = useTasks(),
      _useTasks$state = _useTasks.state,
      submittedTasks = _useTasks$state.submittedTasks,
      deletedTasks = _useTasks$state.deletedTasks; // holds references to task objects we already looked at or were created prior to
  // rendering this page - which we do not care about so we use those as the initial value of the ref.


  var visitedTasksRef = useRef(submittedTasks);
  var visitedDeletedTasksRef = useRef(deletedTasks);
  var updateMyTodos = infoMyTodos.mutate;
  var updateUpcoming = infoUpcoming.mutate;
  useEffect(function () {
    if (submittedTasks.length === 0 && deletedTasks.length === 0) {
      return;
    }

    var results = {
      drafts: [],
      upcoming: []
    };

    var _iterator = _createForOfIteratorHelper(submittedTasks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var submittedTask = _step.value;

        if (!visitedTasksRef.current.includes(submittedTask)) {
          // task was handed off
          if (submittedTask.taskView === TaskViewType.TASK_VIEW_TYPE_UPCOMING) {
            results.upcoming.push(submittedTask);
          } else {
            // else we can assume was draft
            results.drafts.push(submittedTask);
          }

          visitedTasksRef.current = [submittedTask].concat(_toConsumableArray(visitedTasksRef.current));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(deletedTasks),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var deletedTask = _step2.value;

        if (!visitedDeletedTasksRef.current.includes(deletedTask)) {
          if (deletedTask.taskView === TaskViewType.TASK_VIEW_TYPE_UPCOMING) {
            results.upcoming.push(deletedTask);
          } else {
            results.drafts.push(deletedTask);
          }

          visitedDeletedTasksRef.current = [deletedTask].concat(_toConsumableArray(visitedDeletedTasksRef.current));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (results.drafts.length > 0) {
      void updateMyTodos();
    }

    if (results.upcoming.length > 0) {
      void updateUpcoming();
    }
  }, [submittedTasks, deletedTasks, updateUpcoming, updateMyTodos]);
  return /*#__PURE__*/_jsx(TodosPageV2, {
    dataDraft: infoMyTodos,
    dataCompleted: infoCompleted,
    dataUpcoming: infoUpcoming,
    dataInProgress: infoInProgress,
    feedbackCategories: feedbackCategories
  });
};

var TodosPage = function TodosPage(_ref2) {
  var feedbackCategories = _ref2.feedbackCategories,
      tasksDraft = _ref2.tasksDraft,
      tasksComplete = _ref2.tasksComplete,
      tasksUpcoming = _ref2.tasksUpcoming,
      tasksInProgress = _ref2.tasksInProgress,
      swrCacheKey = _ref2.swrCacheKey;
  return /*#__PURE__*/_jsx(TodosV2Page, {
    feedbackCategories: feedbackCategories,
    tasksDraft: tasksDraft,
    tasksComplete: tasksComplete,
    tasksInProgress: tasksInProgress,
    tasksUpcoming: tasksUpcoming,
    swrCacheKey: swrCacheKey
  });
};

TodosPage.layout = {
  type: 'poplar'
};
export var __N_SSP = true;
export default _withSuperJSONPage(withPageTitle(TodosPage)({
  translationKey: 'tasks-page-title',
  translationNS: 'tasks'
}));